import { createFeatureSelector } from "redux/utility"

export const reducerName = "ui" as const

export const createUiFeatureSelector = (featureName: string): unknown =>
    createFeatureSelector(`${reducerName}.${featureName}`)
